module.exports = __webpack_public_path__ + "img/well-LaidPlans.652cbd00.png";